/**
 * Integrations is a tenant-admin page. Support, dealer, and operator shells do not get the item.
 */
export function canSeeAskSbIntegrations({
  role,
  dealerShell = false,
  supportShell = false,
  operatorNav = false,
} = {}) {
  if (dealerShell || supportShell || operatorNav) return false;
  return role === 'tenant_admin' || role === 'superadmin';
}
